import { render, staticRenderFns } from "./GenerateShipmentsManually.vue?vue&type=template&id=4cd859c0"
import script from "./GenerateShipmentsManually.vue?vue&type=script&lang=js"
export * from "./GenerateShipmentsManually.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports